module.exports = __webpack_public_path__ + "static/media/blog-10.64dc188d.svg";